import { useItem } from '@/composables/item'
import { reportService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'

export const useReportStore = defineStore(
	'report',
	() => {
		const {
			items,
			show,
			create,
			update,
			remove,
			attach,
			detach,
			getItem,
			invalidateData,
		} = useItem(reportService, 'reports', 'Report', {
			options: { saveCreated: false, postOnPut: true },
		})

		const onlyActive = ref(true)
		const selectedStatus = ref<{ id: number; show: boolean }[]>([])

		return {
			onlyActive,
			selectedStatus,
			items,
			show,
			create,
			update,
			remove,
			attach,
			detach,
			getItem,
			invalidateData,

			directEmail: reportService.directEmail,
		}
	},
	{
		persist: {
			storage: sessionStorage,
			pick: ['onlyActive', 'selectedStatus'],
			beforeHydrate: (ctx) => {
				ctx.store.$patch({
					selectedStatus: ctx.store.selectedStatus.filter(
						(item) => typeof item === 'object'
					),
				})
			},
		},
	}
)

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useReportStore, import.meta.hot))
}
